import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import LoginPage from 'pages/Login';
import CreateOrLogin from 'pages/Setup/CreateOrLogin';
import UserRoute from './UserRoute';
import Setup from './Setup';

const SetupRoutes = ({ location }) => (
  <React.Fragment>
    <Switch>
      <Route
        exact
        path="/setup/login"
        component={ LoginPage }
      />
      <Route
        exact
        path="/setup/createorlogin"
        component={ CreateOrLogin }
      />
    </Switch>
    <UserRoute
      redirectRoute="/setup/createorlogin"
      route="/"
      component={ Setup }
      location={ location }
    />
  </React.Fragment>
);

SetupRoutes.propTypes = {
  location: PropTypes.object.isRequired
};

export default SetupRoutes;
